import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {when} from 'lit/directives/when.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import {baseProfileOptions} from '../../../sectionConfig';

@customElement('page-light-summary')
export class PageLightSummary extends connect(store)(LitElement) {

	static styles = [
		css`

		.content {
			display: block;
		}

		.description {
			margin-top: var(--specsheet-print-large-gap);
			max-width: 70vw;
		}

		.description p {
			font-size: var(--font-size-widget-small-mono);
			line-height: 16px;
			max-width: 70vw;
		}

		.numbers {
			background-color: transparent;
			border: 1px solid var(--color-black);
			box-shadow: none;
			color: var(--color-black);
			display: inline-block;
			font: var(--font-specsheet-print-light);
			padding: 5px 10px;
			text-decoration: none;
		}

		.info {
			width: 50vw;
			left: 0;
		}

		.info h1 {
			font: var(--font-info-light);
			color: var(--color-black);
			letter-spacing: 2px;
			border: none;
		}

		.img-container img {
			max-height: 80mm;
			width: 100vw;
			object-fit: cover;
			margin-top: 6mm;
		}
			`
		];

		constructor() {
			super();
			store.subscribe(() => this.requestUpdate());
		}

		stateChanged(state) {
			this.state = state;
			this.translations = state.productData.translations;
			this.decisions = state.decisions.data;
			this.profile = state.lightProfile.data.profile;
			this.lightProfile = state.lightProfile.data;
			this.lang = state.status.lang;
			this.status = state.status;
			this.baseProfileOptions = this.baseProfileData(this.lightProfile.project.base);
			this.shortNumberProductModel = state.shortNumber.data.ProductModel ?? '';
			this.shortNumberCircularProfile = state.shortNumber.data.CircularProfile ?? '';
		}
		baseProfileData(id) {
			return baseProfileOptions.find(baseProfileOption => baseProfileOption.id === id);
		}

		render() {
			const s = this.state;
			const label = this.baseProfileOptions ? this.baseProfileOptions.label[this.lang] : '';
			const description = this.baseProfileOptions ? this.baseProfileOptions.description[this.lang] : '';
			this.base = baseProfileOptions.find(base => base.id === this.lightProfile.project.base);
			return html`
				<div slot="content" class="lightProfilePdf">
					<page-header content-title="${msg('Nature-Centric Lighting')}" intro-title="${msg('Light in natural rhythm for people, plants and animals')}" label-choice="summary"></page-header>
					<div class="description">
						<p>${description}</p>
						<a href="${this.status.host}${this.status.baseUrl}${this.status.region}/${this.status.lang}/${this.status.family}/sections/${this.status.mode}/${this.status.shortKey}" class="numbers">
							${this.shortNumberCircularProfile}
							${when(this.shortNumberProductModel !== '', () => html`- ${this.shortNumberProductModel}`)}
						</a>
					</div>
					<div class="img-container">
						<img alt="" src="${this.base?.specimg}"/>
					</div>
					<div class="img-container">
						<img alt="" src="${this.base?.specimg2}"/>
					</div>
				</div>
			<page-footer></page-footer>
			`;
		}
	}
